/** Orders CREATED in one calendar window, with their outcomes known now. */
export const BUYOUT_COHORT_DAYS = 14;
export type BuyoutCohort = {
  from: string; to: string;
  ordered: number; delivered: number; cancelled: number; returned: number; pending: number;
  returnsKnown: boolean;
};

export function buyoutCohortRate(cohort: BuyoutCohort | null | undefined): number | null {
  if (!cohort?.returnsKnown) return null;
  const resolved = cohort.delivered + cohort.cancelled;
  return resolved > 0 ? Math.round(Math.max(0, cohort.delivered - cohort.returned) / resolved * 1000) / 10 : null;
}

/** Pool unit counts, never average percentages of models or sizes. */
export function combineBuyoutCohorts(values: readonly (BuyoutCohort | null | undefined)[]): BuyoutCohort | null {
  const first = values[0];
  if (!first || values.some(value => !value || value.from !== first.from || value.to !== first.to)) return null;
  return values.reduce<BuyoutCohort>((total, value) => ({ ...total,
    ordered: total.ordered + value!.ordered, delivered: total.delivered + value!.delivered,
    cancelled: total.cancelled + value!.cancelled, returned: total.returned + value!.returned,
    pending: total.pending + value!.pending, returnsKnown: total.returnsKnown && value!.returnsKnown,
  }), { from: first.from, to: first.to, ordered: 0, delivered: 0, cancelled: 0, returned: 0, pending: 0, returnsKnown: true });
}

export function buyoutCohortTooltip(cohort: BuyoutCohort | null | undefined): string {
  if (!cohort) return "История исходов заказов ещё не загружена";
  const date = (value: string) => value.split("-").reverse().join(".");
  const details = `Заказы, оформленные ${date(cohort.from)}–${date(cohort.to)}: ${cohort.ordered} шт. Выкупили ${cohort.delivered}, отменили или отказались ${cohort.cancelled}, вернули после покупки ${cohort.returned}. В пути и незавершённые: ${cohort.pending} — не входят в процент.`;
  if (!cohort.returnsKnown) return `${details} История клиентских возвратов не загружена полностью или возврат нельзя однозначно связать с товаром. Процент пока не рассчитан.`;
  if (cohort.delivered + cohort.cancelled === 0) return `${details} Завершённых заказов пока нет.`;
  return `${details} (${cohort.delivered} − ${cohort.returned}) ÷ (${cohort.delivered} + ${cohort.cancelled}) × 100%. Статусы и поздние возвраты могут изменить результат.`;
}
